import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const movies = featuredMovies;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % movies.length);
  }, [movies.length]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + movies.length) % movies.length);
  }, [movies.length]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = movies[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0 flex transition-transform duration-700 ease-in-out">
        {movies.map((m, i) => (
          <div
            key={m.id}
            className="absolute inset-0 transition-opacity duration-700"
            style={{ opacity: i === current ? 1 : 0 }}
          >
            <img
              src={m.poster}
              alt={m.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-background-50/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent" />

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1400px] mx-auto w-full px-4 md:px-6">
          <div className="max-w-xl">
            <div className="flex items-center gap-2 mb-4">
              <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                推荐大片
              </span>
              <span className="flex items-center gap-1 text-foreground-300">
                <i className="ri-star-fill text-primary-500"></i>
                <span className="text-sm font-semibold text-foreground-950">{movie.rating}</span>
              </span>
            </div>
            <h1 className="text-2xl md:text-5xl font-heading font-black text-foreground-950 mb-3 md:mb-4 leading-tight">
              {movie.title}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed line-clamp-2 md:line-clamp-3 mb-5 md:mb-6">
              {movie.description}
            </p>
            <div className="flex items-center gap-3 mb-5 md:mb-6 flex-wrap">
              <span className="text-xs md:text-sm text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-lg">
                {movie.year}
              </span>
              <span className="text-xs md:text-sm text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-lg">
                {movie.duration}
              </span>
              <span className="text-xs md:text-sm text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-lg">
                {movie.views}次播放
              </span>
            </div>
            <Link
              to={`/movie/${movie.id}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-all"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-all"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {movies.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all ${
              i === current
                ? 'bg-primary-500 w-6'
                : 'bg-foreground-400/50 hover:bg-foreground-400'
            }`}
            aria-label={`第${i + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}